/* eslint react/prop-types: off */
/* eslint no-unused-vars: off */

import 'chartjs-adapter-dayjs-3';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { CandlestickChart } from 'echarts/charts';
import {
  DataZoomComponent,
  DataZoomInsideComponent,
  GridComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { getColor } from 'helpers/utils';
import React, { useRef } from 'react';
import dayjs from 'dayjs';
/* CandleChartWidget
 * This widget is used to display a candlestick chart.
 * It uses the echarts library to render the chart.
 * The chart is responsive and will resize based on the parent container.
 */

// Import the necessary components from echarts
echarts.use([
  CandlestickChart,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  DataZoomInsideComponent
]);

const getOptions = (xAxisData, seriesData, data, zoomStart, zoomEnd) => ({
  tooltip: {
    trigger: 'axis',
    padding: [10, 10],
    backgroundColor: getColor('100'),
    borderColor: getColor('300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1
  },
  xAxis: {
    data: xAxisData,
  },
  yAxis: {},
  series: [
    {
      name: 'candlestick',
      type: 'candlestick',
      data: seriesData,
      itemStyle: {
        color: getColor('warning'),
        color0: getColor('primary'),
        borderColor: getColor('warning'),
        borderColor0: getColor('primary')
      }
    }
  ],
  grid: {
    right: 23,
    left: 12,
    bottom: 0,
    top: '20px',
    containLabel: true
  }
});

export default function CandleChartWidget(props) {
  const chartRef = useRef();

  let xAxisData = [];
  let seriesData = [];
  let testVal = props.data[0][Object.keys(props.data[0])[0]];
  let isDate = isNaN(testVal);

  for (let i = 0; i < props.data.length; i++) {
    if (isDate) {
      xAxisData.push(
        dayjs(props.data[i][Object.keys(props.data[i])[0]]).format('HH:mm')
      );
    }
    else {
      xAxisData.push(
        props.data[i][Object.keys(props.data[i])[0]]
      );
    }
    seriesData.push([
      props.data[i][Object.keys(props.data[i])[1]],
      props.data[i][Object.keys(props.data[i])[2]],
      props.data[i][Object.keys(props.data[i])[4]],
      props.data[i][Object.keys(props.data[i])[3]]
    ]);
  }

  return (
    <ReactEChartsCore
      ref={chartRef}
      echarts={echarts}
      option={getOptions(xAxisData, seriesData, props.data, 0, 0)}
      style={{ width: '100%', height: '100%' }}
    />
  );
}
